import { render } from "./InStorageRecord.vue?vue&type=template&id=69c79b04&scoped=true"
import script from "./InStorageRecord.vue?vue&type=script&lang=js"
export * from "./InStorageRecord.vue?vue&type=script&lang=js"

import "./InStorageRecord.vue?vue&type=style&index=0&id=69c79b04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c79b04"]])

export default __exports__